import React, { useState, useEffect } from "react";
import "./accountSetting.css";
import { Container, Row, Col } from "react-bootstrap";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import WmTextarea from "../ui-components/wm-form-components/textarea/Wm.Textarea";
import Wmswitch from "../ui-components/wm-form-components/switch/Wm-switch";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import axios from "axios";
import { useHistory } from "react-router-dom";
import API_ENDPOINT from "../wm.api.service";
import { getUsersEntireData } from "../functions/apis";
import { wordCountFun } from "../functions/general";
import CircularProgress from "@material-ui/core/CircularProgress";
import Multiselect from "multiselect-react-dropdown";
import { ThumbUpIcon, XIcon } from "@heroicons/react/outline";
import insta from "../assets/images/social_Icons/instagram.svg";
import fb from "../assets/images/social_Icons/facebook.svg";
import linkin from "../assets/images/social_Icons/linkedin.svg";
import twitter from "../assets/images/social_Icons/twitter.svg";
import yt from "../assets/images/social_Icons/youtube.svg";
import be from "../assets/images/social_Icons/behance.png";
import dr from "../assets/images/social_Icons/dribble.png";
import pin from "../assets/images/social_Icons/pinterest.png";
import eye from "../assets/images/eye.png";
import hide from "../assets/images/noteye.png";
import {
  editFirstName,
  editLastName,
  editUserName,
  editEmail,
  editPhone,
  editBio,
  editFb,
  editInsta,
  editLinkIn,
  editTwi,
  editYt,
  editBe,
  editDrib,
  editPin,
  editDOB,
  editGender,
  editCountry,
  editState,
  editCity,
  editPincode,
  setUser,
  editWebsite,
  setMasterData,
  setLanguages,
  removeLanguages,
} from "../services/actions/actions";
import WmModals from "../modals/Wm.Modals";
const cookies = new Cookies();
function AccountSetting({
  rootData,
  editFname,
  editLname,
  editUsername,
  editEmails,
  editPhones,
  editBios,
  editFbs,
  editInstas,
  editLinkIns,
  editTwis,
  editYts,
  editBes,
  editDribs,
  editPins,
  editDOBs,
  editGenders,
  editCountrys,
  editStates,
  editCitys,
  editPincodes,
  setUsers,
  editWebsites,
  setData,
  handleSetLanguages,
  handleRemoveLanguages,
}) {
  var token = cookies.get("wmtoken");
  var user = decode(cookies.get("wmusers"));
  const [accountSuccesModal, setSuccessModal] = useState(false);
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = "members";
  }
  const history = useHistory();
  const [wordCount, setWordCount] = useState(0);
  const [countBool, setCountBool] = useState(false);
  const bioWordCount = (words) => {
    setWordCount(words.length);
    var maxLength = 150;
    if (wordCountFun(words, maxLength)) {
      setCountBool(true);
    }
    if (!wordCountFun(words, maxLength)) {
      setCountBool(false);
    }
  };
  useEffect(() => {
    bioWordCount(rootData.bio ? rootData.bio : "");
  }, []);
  const [selectedLanguage, setSelectedLanguage] = useState([]);
  const [isAccoundEditing, setIsAccountEditing] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [portfolioLink, setPortfolioLink] = useState("");
  const [workSample1, setWorkSample1] = useState("");
  const [workSample2, setWorkSample2] = useState("");

  // Initialize roles from rootData
  useEffect(() => {
    let roles = rootData?.userData?.profile_data?.roles;
    if (roles) {
      try {
        const rolesArray =
          typeof roles === "string" ? JSON.parse(roles) : roles;
        setSelectedRoles(Array.isArray(rolesArray) ? rolesArray : []);
      } catch (e) {
        setSelectedRoles([]);
      }
    }
  }, [rootData]);

  // Initialize portfolio and work samples from rootData
  useEffect(() => {
    if (rootData?.userData?.profile_data) {
      setPortfolioLink(rootData.userData.profile_data.portfolio_link || "");
      setWorkSample1(rootData.userData.profile_data.work_sample_link_1 || "");
      setWorkSample2(rootData.userData.profile_data.work_sample_link_2 || "");
    }
  }, [rootData]);

  const handleRoleChange = (role) => {
    setSelectedRoles((prev) => {
      if (prev.includes(role)) {
        return prev.filter((r) => r !== role);
      } else {
        return [...prev, role];
      }
    });
  };

  const userAccountEdit = (e) => {
    setIsAccountEditing(true);
    e.preventDefault();

    if (token) {
      var fd = new FormData();
      fd.append("token", decode(token));
      fd.append("identity", API_ENDPOINT.identity);
      fd.append("fname", rootData.fname);
      fd.append("lname", rootData.lname);
      fd.append("email", rootData.email);
      fd.append("bio", rootData.bio);
      fd.append("username", rootData.username);
      fd.append("contact", rootData.phone);
      fd.append("dob", rootData.dob);
      fd.append("gender", rootData.gender);
      fd.append("country", rootData.country);
      fd.append("city", rootData.city);
      fd.append("state", rootData.state);
      fd.append("pincode", rootData.pincode);
      fd.append("fb", rootData.fb);
      fd.append("insta", rootData.insta);
      fd.append("linkedin", rootData.linkdin);
      fd.append("twitter", rootData.twitter);
      fd.append("youtube", rootData.youtube);
      fd.append("behance", rootData.behance);
      fd.append("dribble", rootData.dribble);
      fd.append("pintrest", rootData.pintrest);
      fd.append("website", rootData.website);
      fd.append("languages", JSON.stringify(rootData.languageSelected));
      fd.append("roles", JSON.stringify(selectedRoles));
      fd.append("portfolio_link", portfolioLink);
      fd.append("work_sample_link_1", workSample1);
      fd.append("work_sample_link_2", workSample2);
      axios({
        url: `${API_ENDPOINT.apiURL}Profile/updateProfileDetails`,
        method: "POST",
        data: fd,
      })
        .then(function () {
          setIsAccountEditing(false);
          getUsersEntireData().then(function (res) {
            setData(res);
            setSuccessModal(true);
          });
        })
        .catch(function (err) {
          setIsAccountEditing(false);
          alert(err.response.data.message);
        });
    }
  };
  const backToLoginPage = () => {
    history.push("/login");
  };
  const [isChangePassword, setIsChangePassword] = useState(false);
  const back = () => {
    {
      user === "members" ? history.push("/user") : history.push("/i/institute");
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const getWhoIsUser = () => {
    var token = cookies.get("wmtoken");
    var fd = new FormData();
    {
      token && fd.append("token", decode(token));
    }
    fd.append("identity", "wmhandler");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/fetchUserData`,
      data: fd,
    })
      .then(function (response) {
        setUsers(response.data[0]);
      })
      .catch(function (err) {
        console.log(err);
      });
  };
  const [isUserDeactiveAccountToggle, setUserDeactiveAccount] = useState(false);
  const userDeactiveToggle = () => {
    setUserDeactiveAccount(true);
  };
  const [deactiveErr, setDeactiveErr] = useState("");
  const [isDeactivePassword, setIsDeactivePassword] = useState(false);
  const [deactivePass, setDeactivePass] = useState("");
  const deactivateUser = () => {
    setIsDeactivePassword(true);
    var token = cookies.get("wmtoken");
    var fd = new FormData();
    {
      token && fd.append("token", decode(token));
    }
    fd.append("identity", "wmhandler");
    fd.append("field_id", JSON.parse(decode(token)).id);
    fd.append("field_name", "PROFILE");
    fd.append("password", deactivePass);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Profile/disableUserDataEntry`,
      data: fd,
    })
      .then(function (response) {
        setIsDeactivePassword(false);
        cookies.remove("wmtoken", {
          domain: ".spiralbound.in",
        });
        // cookies.remove("wmtoken", { path: "/" });
        history.replace("/");
      })
      .catch(function (err) {
        console.log(err);
        setIsDeactivePassword(false);
        setDeactiveErr(err.response.data.message);
      });
  };
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confNewPassText, setConfNewPassText] = useState("");
  const [isChangePass, setIsChangePass] = useState(false);
  const [changeErr, setChangeErr] = useState("");
  const ChangePassword = () => {
    setIsChangePass(true);
    if (newPass !== confNewPassText) {
      setChangeErr("New Password Does Not Match With Confirm Password");
      setIsChangePass(true);
    } else {
      var token = cookies.get("wmtoken");
      var fd = new FormData();
      {
        token && fd.append("token", decode(token));
      }
      fd.append("identity", "wmhandler");
      fd.append("password", oldPass);
      fd.append("new_pass", newPass);
      fd.append("new_pass_confirm", confNewPassText);
      axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Profile/changePassword`,
        data: fd,
      })
        .then(function (response) {
          setIsChangePass(false);
          cookies.remove("wmtoken", {
            domain: ".spiralbound.in",
          });
          cookies.remove("wmtoken", { path: "/" });
          history.replace("/");
        })
        .catch(function (err) {
          console.log(err);
          setIsChangePass(false);
          setChangeErr(err.response.data.message);
        });
    }
  };
  const sendMail = () => {
    var fd = new FormData();
    fd.append("email", rootData.email);
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/forgotPassword`,
      data: fd,
    })
      .then((response) => {})
      .catch((err) => {
        alert(err.response.data.message);
      });
  };
  const logout = () => {
    cookies.remove("wmtoken", {
      domain: ".spiralbound.in",
    });
    cookies.remove("wmtoken", { path: "/" });
    history.replace("/");
  };
  const [languages, setLanguages] = useState([]);
  useEffect(() => {
    getLanguage();
  }, []);
  const getLanguage = () => {
    fetch("./languages.json")
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // Work with JSON data here
        setLanguages(data);
      })
      .catch((err) => {
        console.log("Error Reading data " + err);
      });
  };
  const selectLanguage = (selectedList, selectedItem) => {
    setSelectedLanguage(selectedList);
  };
  return (
    <>
      {token ? (
        <>
          <div className="accountSetting">
            <form>
              <Container className="mb-10 lg:mb-0">
                <Row>
                  <Col md={12}>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="First name" className="text-sm">
                        {user === "institue" ? "Institute Name" : "First Name"}
                      </label>
                      <Wminput
                        type="text"
                        name="firstName"
                        value={rootData.fname}
                        onChange={(e) => editFname(e.target.value)}
                      />
                    </div>
                    <div
                      className="wm-form-group flex flex-col mb-4"
                      hidden={user === "members" ? false : true}
                    >
                      <label htmlFor="Last Name" className="text-sm">
                        Last Name
                      </label>
                      <Wminput
                        type="text"
                        name="lastName"
                        value={rootData.lname}
                        onChange={(e) => editLname(e.target.value)}
                      />
                    </div>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="Username" className="text-sm">
                        Username{" "}
                      </label>
                      <Wminput
                        type="text"
                        name="username"
                        value={rootData.username}
                        onChange={(e) => editUsername(e.target.value)}
                      />
                    </div>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="email" className="text-sm">
                        Email
                      </label>
                      <Wminput
                        type="email"
                        name="email"
                        className="lowercase"
                        disabled
                        value={rootData.email}
                        onChange={(e) => editEmails(e.target.value)}
                      />
                    </div>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="phone" className="text-sm">
                        Phone
                      </label>

                      <Wminput
                        type="tel"
                        name="phone"
                        maxlength={10}
                        value={rootData.phone}
                        onChange={(e) =>
                          editPhones(e.target.value.replace(/[^0-9.]/g, ""))
                        }
                      />
                    </div>
                    <div
                      className="wm-form-group flex flex-col mb-4"
                      hidden={user === "members" ? true : false}
                    >
                      <label htmlFor="phone" className="text-sm">
                        Website
                      </label>

                      <Wminput
                        type="url"
                        name="websiteurl"
                        placeholder="http://example.com"
                        value={rootData.website}
                        onChange={(e) => editWebsites(e.target.value)}
                      />
                      <div>
                        <small className="manpro text-gray-600">
                          Please type in the correct URL for the website
                          http://example.com/
                        </small>
                      </div>
                    </div>
                    <div
                      className="wm-form-group flex flex-col mb-4"
                      hidden={user === "members" ? false : true}
                    >
                      <label htmlFor="Bio" className="text-sm">
                        Bio
                      </label>
                      <WmTextarea
                        name="bio"
                        id="bio_textarea"
                        value={rootData.bio}
                        onChange={(e) => editBios(e.target.value)}
                        onKeyUp={(e) => bioWordCount(e.target.value)}
                        maxLength="150"
                      />
                      <small
                        className={`mt-2 ${
                          countBool ? "text-red-500" : "text-gray-400"
                        }`}
                      >
                        {wordCount}/150
                      </small>
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={fb} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editFbs(e.target.value)}
                        value={rootData.fb}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your Facebook url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={insta} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editInstas(e.target.value)}
                        value={rootData.insta}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your Instagram url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={linkin} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editLinkIns(e.target.value)}
                        value={rootData.linkdin}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your LinkedIn url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img
                          src={twitter}
                          alt="ico"
                          className="w-full h-full"
                        />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editTwis(e.target.value)}
                        value={rootData.twitter}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your Twitter url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={yt} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editYts(e.target.value)}
                        value={rootData.youtube}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your Youtube url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={be} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editBes(e.target.value)}
                        value={rootData.behance}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your Behance url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={dr} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editDribs(e.target.value)}
                        name="socio-icon-input"
                        value={rootData.dribble}
                        className="w-full pl-3"
                        placeholder="Add your Dribbble url here..."
                      />
                    </div>
                    <div className="form-social-input-wrapper flex rounded overflow-hidden mb-3">
                      <div className="socio-lable-icon w-10 h-10 p-2 bg-gray-300">
                        <img src={pin} alt="ico" className="w-full h-full" />
                      </div>
                      <input
                        type="url"
                        onChange={(e) => editPins(e.target.value)}
                        value={rootData.pintrest}
                        name="socio-icon-input"
                        className="w-full pl-3"
                        placeholder="Add your Pintrest url here..."
                      />
                    </div>
                  </Col>
                  {user === "institue" ? (
                    ""
                  ) : (
                    <Col md={12}>
                      <div className="mb-4 language-select">
                        <label htmlFor="Date of Birth" className="text-sm">
                          {" "}
                          Laguages known
                        </label>

                        <Multiselect
                          selectedValues={rootData.languageSelected}
                          options={languages}
                          displayValue="name"
                          onSelect={(selectedList) =>
                            handleSetLanguages(selectedList)
                          }
                          onRemove={(selectedList) =>
                            handleRemoveLanguages(selectedList)
                          }
                        />
                      </div>
                    </Col>
                  )}
                  {user === "institue" ? (
                    ""
                  ) : (
                    <Col md={12}>
                      <div className="mb-4">
                        <label
                          htmlFor="roles"
                          className="text-sm font-medium text-gray-700 mb-3 block"
                        >
                          Your roles in Film/TV (Select all that apply)
                        </label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                          {[
                            "Writer",
                            "Actor",
                            "Sound Designer",
                            "Director",
                            "Editor",
                            "Film Student",
                            "Producer",
                            "Cinematographer",
                            "Other",
                          ].map((role) => (
                            <label
                              key={role}
                              className="flex items-center space-x-2 cursor-pointer p-2 rounded hover:bg-gray-50 transition"
                            >
                              <input
                                type="checkbox"
                                checked={selectedRoles.includes(role)}
                                onChange={() => handleRoleChange(role)}
                                className="w-4 h-4 cursor-pointer accent-purple-500"
                              />
                              <span className="text-sm">{role}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    </Col>
                  )}
                  {user === "institue" ? (
                    ""
                  ) : (
                    <>
                      <Col md={12}>
                        <div className="mb-3 mt-2">
                          <h3 className="text-base font-semibold text-gray-800">
                            Portfolio & Work Samples
                          </h3>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="wm-form-group flex flex-col mb-4">
                          <label htmlFor="portfolioLink" className="text-sm">
                            Portfolio Link
                          </label>
                          <Wminput
                            type="url"
                            name="portfolioLink"
                            placeholder="https://yourportfolio.com"
                            value={portfolioLink}
                            onChange={(e) => setPortfolioLink(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="wm-form-group flex flex-col mb-4">
                          <label htmlFor="workSample1" className="text-sm">
                            Work Sample Link 1
                          </label>
                          <Wminput
                            type="url"
                            name="workSample1"
                            placeholder="https://youtu.be/example"
                            value={workSample1}
                            onChange={(e) => setWorkSample1(e.target.value)}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="wm-form-group flex flex-col mb-4">
                          <label htmlFor="workSample2" className="text-sm">
                            Work Sample Link 2
                          </label>
                          <Wminput
                            type="url"
                            name="workSample2"
                            placeholder="https://youtu.be/example"
                            value={workSample2}
                            onChange={(e) => setWorkSample2(e.target.value)}
                          />
                        </div>
                      </Col>
                    </>
                  )}
                  <Col md={6}>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="Date of Birth" className="text-sm">
                        {" "}
                        {user === "institue" ? "DOE" : "DOB"}
                      </label>
                      <Wminput
                        type="date"
                        name="dob"
                        value={rootData.dob}
                        onChange={(e) => editDOBs(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      className="wm-form-group flex flex-col mb-4"
                      hidden={user === "members" ? false : true}
                    >
                      <label htmlFor="Gender" className="text-sm">
                        Gender
                      </label>
                      <select
                        className="selectWm border-bottom border-gray-300"
                        value={rootData.gender}
                        onChange={(e) => editGenders(e.target.value)}
                      >
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="country" className="text-sm">
                        {" "}
                        Country
                      </label>
                      <Wminput
                        type="text"
                        name="country"
                        value={rootData.country}
                        onChange={(e) => editCountrys(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="State" className="text-sm">
                        State
                      </label>
                      <Wminput
                        type="text"
                        name="State"
                        value={rootData.state}
                        onChange={(e) => editStates(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="City" className="text-sm">
                        City
                      </label>
                      <Wminput
                        type="text"
                        name="City"
                        value={rootData.city}
                        onChange={(e) => editCitys(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="Pincode" className="text-sm">
                        Pincode
                      </label>
                      <Wminput
                        type="text"
                        name="Pincode"
                        value={rootData.pincode}
                        onChange={(e) => editPincodes(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <label htmlFor="deactive account" className="text-sm mr-3">
                      Deactive Account
                    </label>

                    <Wmswitch
                      color="danger"
                      checked={isUserDeactiveAccountToggle}
                      onChange={() => userDeactiveToggle()}
                    />
                  </Col>
                  <Col md={12}>
                    <div className="wm-form-group flex mt-4">
                      <Wmbutton
                        className="w-40 mr-3 h-10 rounded"
                        bordered
                        label="Change Password"
                        type="button"
                        color="primary-border"
                        onClick={() => {
                          setIsChangePassword(true);
                          sendMail();
                        }}
                      />
                      <Wmbutton
                        className="w-20 h-10 rounded mr-3"
                        label={
                          isAccoundEditing ? (
                            <CircularProgress
                              className="loader_size_xsm"
                              style={{ color: "white" }}
                            />
                          ) : (
                            "Save"
                          )
                        }
                        type="button"
                        color="primary"
                        onClick={(e) => userAccountEdit(e)}
                      />
                      <Wmbutton
                        className="w-20 h-10 rounded"
                        bordered
                        label="Back"
                        type="button"
                        color="primary-border"
                        onClick={() => back()}
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
            </form>
          </div>
        </>
      ) : (
        backToLoginPage()
      )}
      <WmModals
        show={isChangePassword}
        onHide={() => {
          setIsChangePassword(false);
          logout();
        }}
        size="md"
      >
        <Container fluid className="py-4">
          <Row>
            <Col md={12}>
              <div className="wm-form-group flex flex-col mb-4">
                <span>
                  Change Password Link has been sent to you registered email
                </span>
              </div>
            </Col>
            <Col md={12}>
              <div className="text-right">
                <Wmbutton
                  label="Done"
                  className="rounded w-20"
                  type="button"
                  color="primary"
                  onClick={() => {
                    setIsChangePassword(false);
                    logout();
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </WmModals>

      <WmModals
        show={isUserDeactiveAccountToggle}
        onHide={() => setUserDeactiveAccount(false)}
        size="md"
      >
        <Container fluid className="py-4">
          <Row>
            <Col md={12}>
              <div className="wm-form-group flex flex-col mb-4">
                <label htmlFor="Pincode" className="text-sm">
                  Password
                </label>
                <div className="flex border-b border-gray-300 border-solid">
                  <Wminput
                    type={`${isDeactivePassword ? "text" : "password"}`}
                    name="password_login"
                    className="border-0 flex-1"
                    placeholder="Enter Your Password"
                    value={deactivePass}
                    onChange={(e) => setDeactivePass(e.target.value)}
                  />
                  <img
                    src={isDeactivePassword ? eye : hide}
                    alt="eye"
                    className="w-7 cursor-pointer"
                    onClick={() => setIsDeactivePassword(!isDeactivePassword)}
                  />
                </div>
              </div>
            </Col>
            <Col md={12}>
              {deactiveErr && (
                <span className="text-red-600 text-xs">{deactiveErr}</span>
              )}
            </Col>
            <Col md={12}>
              <div className="text-right">
                <Wmbutton
                  label={
                    isDeactivePassword ? (
                      <CircularProgress
                        className="loader_size_xsm"
                        style={{ color: "white" }}
                      />
                    ) : (
                      "Deactivate Account"
                    )
                  }
                  className="rounded px-2 mr-3"
                  type="button"
                  size="sm"
                  color="danger"
                  onClick={() => deactivateUser()}
                  disable={isDeactivePassword}
                />
                <Wmbutton
                  label="Cancel"
                  onClick={() => setUserDeactiveAccount(false)}
                  className="rounded w-20"
                  type="button"
                  color="primary"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </WmModals>

      <WmModals
        show={accountSuccesModal}
        onHide={() => setSuccessModal(false)}
        size="md"
      >
        <Container fluid className=" overflow-hidden">
          <XIcon
            className="w-6 absolute right-3 top-3 cursor-pointer"
            onClick={() => setSuccessModal(false)}
          />
          <Row>
            <div className=" bg-green-300 w-full flex flex-col items-center justify-center py-10 rounded">
              <ThumbUpIcon className="w-20 text-green-700" />
              <span className="block py-6 text-green-700 manpro font-semibold text-xl">
                Account updated succesfully
              </span>
            </div>
          </Row>
        </Container>
      </WmModals>
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    editFname: (value) => {
      dispatch(editFirstName(value));
    },
    editLname: (value) => {
      dispatch(editLastName(value));
    },
    editUsername: (value) => {
      dispatch(editUserName(value));
    },
    editEmails: (value) => {
      dispatch(editEmail(value));
    },
    editPhones: (value) => {
      dispatch(editPhone(value));
    },
    editWebsites: (value) => {
      dispatch(editWebsite(value));
    },
    editBios: (value) => {
      dispatch(editBio(value));
    },
    editFbs: (value) => {
      dispatch(editFb(value));
    },
    editInstas: (value) => {
      dispatch(editInsta(value));
    },
    editLinkIns: (value) => {
      dispatch(editLinkIn(value));
    },
    editTwis: (value) => {
      dispatch(editTwi(value));
    },
    editYts: (value) => {
      dispatch(editYt(value));
    },
    editBes: (value) => {
      dispatch(editBe(value));
    },
    editDribs: (value) => {
      dispatch(editDrib(value));
    },
    editPins: (value) => {
      dispatch(editPin(value));
    },
    editDOBs: (value) => {
      dispatch(editDOB(value));
    },
    editGenders: (value) => {
      dispatch(editGender(value));
    },
    editCountrys: (value) => {
      dispatch(editCountry(value));
    },
    editStates: (value) => {
      dispatch(editState(value));
    },
    editCitys: (value) => {
      dispatch(editCity(value));
    },
    editPincodes: (value) => {
      dispatch(editPincode(value));
    },
    setUsers: (value) => {
      dispatch(setUser(value));
    },
    setData: (value) => {
      dispatch(setMasterData(value));
    },
    handleSetLanguages: (value) => {
      dispatch(setLanguages(value));
    },
    handleRemoveLanguages: (value) => {
      dispatch(removeLanguages(value));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToState)(AccountSetting);
